/**
 * src/pages/FlowCallback.jsx
 * Página de callback de Flow tras el registro de tarjeta.
 *
 * Flow redirige aquí con query params:
 *   token, usuario_id, tier, customer_id
 *
 * El backend en GET /billing/flow-callback verifica y suscribe.
 * Esta página actúa como intermediaria que llama al backend y redirige.
 */
import { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import api from '../api/client'

export default function FlowCallback() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [estado, setEstado] = useState('procesando')
  const [error, setError] = useState('')

  useEffect(() => {
    async function procesar() {
      const token      = params.get('token')
      const usuarioId  = params.get('usuario_id')
      const tier       = params.get('tier')
      const customerId = params.get('customer_id')

      if (!token || !usuarioId || !tier || !customerId) {
        setEstado('error')
        setError('Parámetros de pago incompletos')
        return
      }

      try {
        const r = await api.get('/billing/flow-callback', {
          params: { token, usuario_id: usuarioId, tier, customer_id: customerId },
        })
        if (r.data.ok) {
          navigate('/onboarding', { replace: true })
        } else {
          setEstado('error')
          setError(r.data.mensaje || 'El registro de tarjeta no fue completado')
        }
      } catch (err) {
        setEstado('error')
        setError(err.response?.data?.detail || 'Error al procesar el pago')
      }
    }

    procesar()
  }, [])

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--color-bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: 'var(--space-4)', padding: 'var(--space-5)',
    }}>
      {estado === 'procesando' ? (
        <>
          <div style={{
            width: '44px', height: '44px',
            border: '3px solid var(--color-border)', borderTopColor: 'var(--color-accent)',
            borderRadius: '50%', animation: 'spin 0.8s linear infinite',
          }} />
          <p style={{ color: 'var(--color-text-2)', fontFamily: 'var(--font-mono)', fontSize: 'var(--text-md)' }}>
            Confirmando tu pago...
          </p>
        </>
      ) : (
        <>
          <div style={{ fontSize: '32px' }}>✗</div>
          <h2 style={{ fontSize: 'var(--text-lg)', color: 'var(--color-text)', margin: 0 }}>Error en el pago</h2>
          <p style={{ color: 'var(--color-error)', fontFamily: 'var(--font-mono)', fontSize: 'var(--text-base)' }}>
            {error}
          </p>
          <button
            onClick={() => navigate('/pricing')}
            style={{
              marginTop: 'var(--space-2)', background: 'var(--color-surface)', color: 'var(--color-text)',
              border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)',
              padding: '10px 24px', cursor: 'pointer', fontSize: 'var(--text-md)', fontFamily: 'var(--font-ui)',
            }}
          >
            Volver a precios
          </button>
        </>
      )}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  )
}
